import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import H2 from "../../shared/h2";

const CustomerSafetyCard = (
    {
        heading,
        text,
        image
    }) => {
    return (
        <React.Fragment>
            <div className={"media"} styleName={"styles.safetyCard"}>
                <img src={image} alt="Sell car safely" />
                <div className={"media-body"} styleName={"styles.safetyCardContent"}>
                    <H2 text={heading} />
                    <p>{text}</p>
                </div>
            </div>
        </React.Fragment>
    );
};
CustomerSafetyCard.propTypes = {
    heading: PropTypes.string,
    text: PropTypes.string,
    image: PropTypes.object
};

export default CustomerSafetyCard;
